/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** UUID represents a universally unique identifier. */
  UUID: { input: any; output: any };
  /** Time represents an instance of date and time, formatted as an RFC3339 string. */
  Time: { input: any; output: any };
};

export type Query = {
  __typename?: 'Query';
  cohorts: PaginatedCohorts;
  cohortUsers: PaginatedCohortUsers;
  /**
   * Returns true if the user is a facilitator in any cohort.  If cohortId is provided,
   * it will check if the user is a facilitator for that cohort.
   */
  isFacilitator: Scalars['Boolean']['output'];
  meetings: PaginatedMeetings;
  myConnectData: MyConnectData;
  /**
   * Returns per-(meeting, user) recording-view rollups for the given ContractServices,
   * for the internal analytics sync. Staff-only. The result is paginated (offset-based) so a
   * contract with many recorded meetings cannot produce an unbounded response.
   */
  recordingViewAggregates: PaginatedRecordingViewAggregates;
  series: PaginatedSeries;
  seriesById?: Maybe<Series>;
  seriesByUserKey: Array<Series>;
};

export type QueryCohortsArgs = {
  input: CohortSearchParams;
};

export type QueryCohortUsersArgs = {
  input: CohortUserSearchParams;
};

export type QueryIsFacilitatorArgs = {
  cohortId?: InputMaybe<Scalars['UUID']['input']>;
  userKey: Scalars['String']['input'];
};

export type QueryMeetingsArgs = {
  input: MeetingSearchParams;
};

export type QueryMyConnectDataArgs = {
  input: MyConnectDataParams;
};

export type QueryRecordingViewAggregatesArgs = {
  input: RecordingViewAggregateSearchParams;
};

export type QuerySeriesArgs = {
  input: SeriesSearchParams;
};

export type QuerySeriesByIdArgs = {
  seriesId: Scalars['UUID']['input'];
};

export type QuerySeriesByUserKeyArgs = {
  contentID?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
  programKey?: InputMaybe<Scalars['String']['input']>;
  userKey: Scalars['String']['input'];
};

export type CohortSearchParams = {
  goToMarket?: InputMaybe<GoToMarket>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  learnerUserKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
  sortBy?: InputMaybe<CohortSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<CohortStatus>;
  type?: InputMaybe<CohortType>;
};

export enum GoToMarket {
  B2B = 'B2B',
  B2C = 'B2C',
  B2G = 'B2G',
}

export type PaginationParams = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export enum CohortSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  StartDate = 'START_DATE',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum CohortStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  PreLaunch = 'PRE_LAUNCH',
}

export enum CohortType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Test = 'TEST',
}

export type PaginatedCohorts = {
  __typename?: 'PaginatedCohorts';
  cohorts: Array<Cohort>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type Cohort = {
  __typename?: 'Cohort';
  banner?: Maybe<CohortBanner>;
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  endDate?: Maybe<Scalars['Time']['output']>;
  goToMarket: GoToMarket;
  id: Scalars['UUID']['output'];
  maxSeriesSwitches: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  relevantEnrollments?: Maybe<Array<RelevantEnrollment>>;
  showLeaderboard: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['Time']['output']>;
  status: CohortStatus;
  type: CohortType;
  updatedAt: Scalars['Time']['output'];
};

export type CohortBanner = {
  __typename?: 'CohortBanner';
  buttonText: Scalars['String']['output'];
  subText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RelevantEnrollment = {
  __typename?: 'RelevantEnrollment';
  bookingLink: Scalars['String']['output'];
  cohortId: Scalars['UUID']['output'];
  contentId: Scalars['String']['output'];
  contentType: ContentType;
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  programKey: Scalars['String']['output'];
  unenrollOnWithdrawal: Scalars['Boolean']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum ContentType {
  LearningPlan = 'LEARNING_PLAN',
  Program = 'PROGRAM',
}

export type CohortUserSearchParams = {
  cohortId: Scalars['UUID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  hasSeries?: InputMaybe<Scalars['Boolean']['input']>;
  meetingIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  paginationParams?: InputMaybe<PaginationParams>;
  role?: InputMaybe<CohortUserRole>;
  seriesIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sortBy?: InputMaybe<CohortUserSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  userKey?: InputMaybe<Scalars['String']['input']>;
  userKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CohortUserRole {
  Facilitator = 'FACILITATOR',
  Learner = 'LEARNER',
}

export enum CohortUserSortBy {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
}

export type PaginatedCohortUsers = {
  __typename?: 'PaginatedCohortUsers';
  cohortUsers: Array<CohortUser>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CohortUser = {
  __typename?: 'CohortUser';
  bio?: Maybe<Scalars['String']['output']>;
  cohortId: Scalars['UUID']['output'];
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  maxWeeklyMeetings: Scalars['Int']['output'];
  meetingStats: MeetingStats;
  mentorStatus?: Maybe<MentorStatus>;
  roles: Array<CohortUserRole>;
  series: Array<Series>;
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<UserDetails>;
  userKey: Scalars['String']['output'];
};

export type MeetingStats = {
  __typename?: 'MeetingStats';
  absent: Scalars['Int']['output'];
  attended: Scalars['Int']['output'];
  excused: Scalars['Int']['output'];
  /** The percentage of cohort meetings attended or excused by the user. */
  percentage: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  unknown: Scalars['Int']['output'];
};

export type MentorStatus = {
  __typename?: 'MentorStatus';
  isBlocked: Scalars['Boolean']['output'];
  isMentor: Scalars['Boolean']['output'];
};

export type Series = {
  __typename?: 'Series';
  assignmentType: SeriesAssignmentType;
  cohortId: Scalars['UUID']['output'];
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstMeetingStartAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  lastMeetingStartAt?: Maybe<Scalars['Time']['output']>;
  maxSize: Scalars['Int']['output'];
  meetings: PaginatedMeetings;
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userCount: Scalars['Int']['output'];
};

export type SeriesMeetingsArgs = {
  input?: InputMaybe<SeriesMeetingSearchParams>;
};

export enum SeriesAssignmentType {
  Manual = 'MANUAL',
  Self = 'SELF',
}

/** Search params for Meetings resolved under a Series. */
export type SeriesMeetingSearchParams = {
  availability?: InputMaybe<MeetingAvailability>;
  facilitatorUserKey?: InputMaybe<Scalars['String']['input']>;
  learnerUserKey?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
  sortBy?: InputMaybe<MeetingSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  startsAfter?: InputMaybe<Scalars['Time']['input']>;
  startsBefore?: InputMaybe<Scalars['Time']['input']>;
};

export type MeetingAvailability = {
  availableToFacilitators?: InputMaybe<Scalars['Boolean']['input']>;
  availableToFacilitatorUserKey?: InputMaybe<Scalars['String']['input']>;
};

export enum MeetingSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  StartAt = 'START_AT',
}

export type PaginatedMeetings = {
  __typename?: 'PaginatedMeetings';
  hasMore: Scalars['Boolean']['output'];
  meetings: Array<Meeting>;
  totalCount: Scalars['Int']['output'];
};

export type Meeting = {
  __typename?: 'Meeting';
  attendanceRequired: Scalars['Boolean']['output'];
  cohortId: Scalars['UUID']['output'];
  conferenceLink?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the ContractService (from emc-content) attached to this meeting.
   * Only set for Connect Cohort meetings that consume a contract service allocation.
   */
  contractServiceId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  endAt: Scalars['Time']['output'];
  facilitators: Array<CohortUser>;
  facilitatorUserKeys?: Maybe<Array<Scalars['String']['output']>>;
  facilitatorUsers: PaginatedCohortUsers;
  id: Scalars['UUID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  locales: Array<Scalars['String']['output']>;
  maxSize: Scalars['Int']['output'];
  meetingUsers: PaginatedMeetingUsers;
  name: Scalars['String']['output'];
  recordingUrl?: Maybe<Scalars['String']['output']>;
  series?: Maybe<Series>;
  seriesId?: Maybe<Scalars['UUID']['output']>;
  /**
   * Whether the associated ContractService allocation has been consumed (i.e. the
   * meeting ended and the Airflow job moved it from pending to consumed in emc-content).
   */
  serviceConsumed: Scalars['Boolean']['output'];
  startAt: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  /**
   * The Zoom meeting ID for this meeting's conference, persisted when it is scheduled so a Zoom
   * occurrence can be resolved without re-parsing conferenceLink. Set only by staff and service
   * callers; null for meetings with no Zoom conference.
   */
  zoomMeetingId?: Maybe<Scalars['String']['output']>;
};

export type MeetingFacilitatorUsersArgs = {
  input?: InputMaybe<MeetingFacilitatorSearchParams>;
};

export type MeetingMeetingUsersArgs = {
  input?: InputMaybe<MeetingMeetingUserSearchParams>;
};

/** Search params for Facilitator CohortUsers resolved under a Meeting. */
export type MeetingFacilitatorSearchParams = {
  paginationParams?: InputMaybe<PaginationParams>;
  sortBy?: InputMaybe<CohortUserSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  userKey?: InputMaybe<Scalars['String']['input']>;
};

/** Search params for MeetingUsers resolved under a Meeting. */
export type MeetingMeetingUserSearchParams = {
  paginationParams?: InputMaybe<PaginationParams>;
  sortBy?: InputMaybe<MeetingUserSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  userKey?: InputMaybe<Scalars['String']['input']>;
};

export enum MeetingUserSortBy {
  CreatedAt = 'CREATED_AT',
}

export type PaginatedMeetingUsers = {
  __typename?: 'PaginatedMeetingUsers';
  hasMore: Scalars['Boolean']['output'];
  meetingUsers: Array<MeetingUser>;
  totalCount: Scalars['Int']['output'];
};

export type MeetingUser = {
  __typename?: 'MeetingUser';
  attendance?: Maybe<MeetingAttendance>;
  attendanceRequest?: Maybe<MeetingAttendanceRequest>;
  /** Provenance of the attendance record (how/by whom it was set). */
  attendanceSource?: Maybe<AttendanceSource>;
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** Timestamp of the first join click recorded for this user/meeting. */
  joinedAt?: Maybe<Scalars['Time']['output']>;
  /** The entry point the learner joined through, if recorded via a join click. */
  joinSource?: Maybe<JoinSource>;
  meetingId: Scalars['UUID']['output'];
  updatedAt: Scalars['Time']['output'];
  user?: Maybe<UserDetails>;
  userKey: Scalars['String']['output'];
};

export type MeetingAttendance = {
  __typename?: 'MeetingAttendance';
  meetingId: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  status: MeetingAttendanceStatus;
  userKey: Scalars['String']['output'];
};

export enum MeetingAttendanceStatus {
  Absent = 'ABSENT',
  Attended = 'ATTENDED',
  Excused = 'EXCUSED',
}

export type MeetingAttendanceRequest = {
  __typename?: 'MeetingAttendanceRequest';
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  judgeUserKey?: Maybe<Scalars['String']['output']>;
  meetingId: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  requestApproved?: Maybe<Scalars['Boolean']['output']>;
  requestedAttendanceStatus: MeetingAttendanceStatus;
  updatedAt: Scalars['Time']['output'];
  userKey: Scalars['String']['output'];
};

/**
 * Provenance of a meeting_user attendance write. Derived server-side, never supplied
 * by clients. Manual entries take precedence over automatic join-click attendance.
 */
export enum AttendanceSource {
  /** Learner recorded their own attendance via a join click (recordMeetingJoin) */
  LearnerJoin = 'LEARNER_JOIN',
  /** A facilitator manually set attendance */
  ManualFacilitator = 'MANUAL_FACILITATOR',
  /** Internal staff manually set or overrode attendance */
  ManualStaffOverride = 'MANUAL_STAFF_OVERRIDE',
  /** Verified from Zoom's own participant report. Outranks a join click, but never overrides a manual entry. */
  ZoomApi = 'ZOOM_API',
}

/**
 * The surface a learner clicked through to join a meeting. Clients normalize their
 * entry point to one of these values before calling recordMeetingJoin; unrecognized
 * or missing sources are mapped to UNKNOWN so attendance is never lost.
 */
export enum JoinSource {
  /** ICS calendar invite click */
  Calendar = 'CALENDAR',
  /** udacity-web /sessions Join button (PRD: "Classroom live sessions page") */
  Classroom = 'CLASSROOM',
  /** Manually shared link (Slack, etc.) */
  DirectShared = 'DIRECT_SHARED',
  /** Transactional email link */
  Email = 'EMAIL',
  /** Entry point could not be determined */
  Unknown = 'UNKNOWN',
}

export type UserDetails = {
  __typename?: 'UserDetails';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userKey: Scalars['String']['output'];
};

export type MeetingSearchParams = {
  availability?: InputMaybe<MeetingAvailability>;
  cohortId?: InputMaybe<Scalars['UUID']['input']>;
  contractServiceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  facilitatorUserKey?: InputMaybe<Scalars['String']['input']>;
  learnerUserKey?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  meetingId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  sortBy?: InputMaybe<MeetingSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  startsAfter?: InputMaybe<Scalars['Time']['input']>;
  startsBefore?: InputMaybe<Scalars['Time']['input']>;
};

export type MyConnectDataParams = {
  userKey: Scalars['String']['input'];
};

export type MyConnectData = {
  __typename?: 'MyConnectData';
  myCohorts: MyPaginatedCohorts;
  myMeetings: MyPaginatedMeetings;
};

export type MyConnectDataMyCohortsArgs = {
  input: CohortSearchParams;
};

export type MyConnectDataMyMeetingsArgs = {
  input: MeetingSearchParams;
};

export type MyPaginatedCohorts = {
  __typename?: 'MyPaginatedCohorts';
  cohorts: Array<MyCohort>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type MyCohort = {
  __typename?: 'MyCohort';
  availableSeries: PaginatedSeries;
  cohort: Cohort;
  mySeries: PaginatedSeries;
  seriesSwitchesLeft: Scalars['Int']['output'];
};

export type MyCohortAvailableSeriesArgs = {
  input?: InputMaybe<CohortSeriesSearchParams>;
};

export type MyCohortMySeriesArgs = {
  input?: InputMaybe<MySeriesSearchParams>;
};

/** Search params for Series resolved under a Cohort. */
export type CohortSeriesSearchParams = {
  assignmentType?: InputMaybe<SeriesAssignmentType>;
  availability?: InputMaybe<SeriesAvailability>;
  containsUserKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  sortBy?: InputMaybe<SeriesSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type SeriesAvailability = {
  availableToAny?: InputMaybe<Scalars['Boolean']['input']>;
  availableToNone?: InputMaybe<Scalars['Boolean']['input']>;
  availableToUserKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  availableToUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasMeetingsAvailableForFacilitatorUserKey?: InputMaybe<Scalars['String']['input']>;
};

export enum SeriesSortBy {
  CreatedAt = 'CREATED_AT',
  MaxSize = 'MAX_SIZE',
  Name = 'NAME',
}

export type PaginatedSeries = {
  __typename?: 'PaginatedSeries';
  hasMore: Scalars['Boolean']['output'];
  series: Array<Series>;
  totalCount: Scalars['Int']['output'];
};

export type MySeriesSearchParams = {
  assignmentType?: InputMaybe<SeriesAssignmentType>;
  availability?: InputMaybe<SeriesAvailability>;
  name?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  sortBy?: InputMaybe<SeriesSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type MyPaginatedMeetings = {
  __typename?: 'MyPaginatedMeetings';
  hasMore: Scalars['Boolean']['output'];
  meetings: Array<MyMeeting>;
  totalCount: Scalars['Int']['output'];
};

export type MyMeeting = {
  __typename?: 'MyMeeting';
  attendance?: Maybe<MeetingAttendance>;
  attendanceRequest?: Maybe<MeetingAttendanceRequest>;
  meeting: Meeting;
};

/**
 * Search params for the staff-only recording-view aggregate rollups. paginationParams bounds
 * how many (meeting, user) rows are returned per request so a contract with many recorded
 * meetings cannot produce an unbounded response.
 */
export type RecordingViewAggregateSearchParams = {
  contractServiceIds: Array<Scalars['ID']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
};

export type PaginatedRecordingViewAggregates = {
  __typename?: 'PaginatedRecordingViewAggregates';
  hasMore: Scalars['Boolean']['output'];
  recordingViewAggregates: Array<RecordingViewAggregate>;
};

/**
 * Per-(meeting, user) rollup of recording-link click-throughs, computed at read time from
 * the append-only meeting_recording_view log. Consumed by the staff-only analytics sync.
 *
 * NOTE: a "view" here is a click-through on the recording link (the learner opened the
 * recording URL), NOT confirmed playback or watch time. There is no signal that the
 * recording was actually watched.
 */
export type RecordingViewAggregate = {
  __typename?: 'RecordingViewAggregate';
  firstViewedAt?: Maybe<Scalars['Time']['output']>;
  lastViewedAt?: Maybe<Scalars['Time']['output']>;
  meetingId: Scalars['ID']['output'];
  userKey: Scalars['String']['output'];
  /**
   * Number of times the learner clicked through to the recording link (link opens), not a
   * measure of watch time or completion.
   */
  viewCount: Scalars['Int']['output'];
};

export type SeriesSearchParams = {
  assignmentType?: InputMaybe<SeriesAssignmentType>;
  availability?: InputMaybe<SeriesAvailability>;
  cohortId?: InputMaybe<Scalars['UUID']['input']>;
  containsUserKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  seriesIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sortBy?: InputMaybe<SeriesSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type Mutation = {
  __typename?: 'Mutation';
  claimMeetings: Scalars['Boolean']['output'];
  createCohorts: Array<Cohort>;
  createCohortUsers: Array<CohortUser>;
  createMeetingAttendanceRequests: Array<MeetingAttendanceRequest>;
  createMeetings: Array<Meeting>;
  createMeetingUsers: Array<MeetingUser>;
  createSeries: Array<Series>;
  createSeriesUsers: Array<SeriesUser>;
  deleteCohort: Scalars['Boolean']['output'];
  deleteCohortUsers: Scalars['Boolean']['output'];
  deleteMeetings: Scalars['Boolean']['output'];
  deleteSeries: Scalars['Boolean']['output'];
  /** @deprecated Use deleteSeriesUsers instead */
  deleteSeriesUser: Scalars['Boolean']['output'];
  deleteSeriesUsers: Scalars['Boolean']['output'];
  /**
   * Distribute users randomly into the provided series as fairly as possible
   * while respecting series maxSize.  If dryRun is true, then no changes will
   * occur, but a preview of the results can be viewed.
   *
   * If it is not possible to distribute the learners into the given space, an
   * error will be returned.
   */
  distributeUsersInSeries: Array<DistributeUsersSeriesSummary>;
  /**
   * Records that an authenticated, invited learner clicked through to join a meeting
   * (the automatic attendance path). Marks them ATTENDED only when they join within the
   * meeting's attendance window ([startAt - grace, endAt]); a join outside that window still
   * returns the provider join URL to redirect to but leaves attendanceStatus null (no
   * attendance recorded). It is idempotent across repeated clicks and never overwrites a
   * manual facilitator/staff attendance entry.
   */
  recordMeetingJoin: RecordMeetingJoinPayload;
  /**
   * Records that an authenticated, invited learner clicked a meeting's recording link
   * (post-session engagement tracking). Each click appends one row; rapid duplicate
   * clicks within a short window are deduplicated. Requires the meeting to have a
   * recording available. Returns the recording URL to redirect to.
   */
  recordRecordingView: RecordRecordingViewPayload;
  /**
   * Resize series allows you to change the maxSize of a series.  If the
   * new maxSize is smaller than the current number of users in the series,
   * then additional series will be created to accommodate the users and
   * the users will be distributed evenly among the newly added series.
   */
  resizeSeries: Array<ResizedSeriesResult>;
  /**
   * Ensures that all cohort facilitators have valid Mentor entries.  Returns
   * a list of faciliators that were "out of sync", or missing Mentor entries.
   * If dryRun is false, then the Mentor entries will be created.
   */
  resyncCohortFacilitators: Array<CohortUser>;
  resyncCohortUserEmails: Scalars['Boolean']['output'];
  switchSeries?: Maybe<SeriesSwitch>;
  /**
   * Records Zoom-verified attendance for a meeting's ended occurrence. Fetches the Zoom
   * participant list, matches participants to the roster by lowercased email, and marks
   * matched learners ATTENDED with ZOOM_API provenance. Nobody is marked absent (absence
   * from a Zoom report is not proof of absence), a manual decision or a pending attendance
   * request is left untouched, and the call is idempotent (a re-run writes nothing and
   * emits no further events). Returns a summary with the unmatched participants so a
   * facilitator can credit dial-ins by hand. Authorized as staff or the meeting's
   * facilitators.
   */
  syncMeetingAttendanceFromZoom: SyncMeetingAttendanceFromZoomResult;
  /** @deprecated Use transferSeriesUsers instead */
  transferSeriesUser: Scalars['Boolean']['output'];
  transferSeriesUsers: Scalars['Boolean']['output'];
  updateCohorts: Array<Cohort>;
  updateCohortUsers: Array<CohortUser>;
  updateMeetingAttendance: Scalars['Boolean']['output'];
  updateMeetingAttendanceRequests: Array<MeetingAttendanceRequest>;
  updateMeetings: Array<Meeting>;
  updateSeries: Array<Series>;
};

export type MutationClaimMeetingsArgs = {
  meetingIDs: Array<Scalars['UUID']['input']>;
};

export type MutationCreateCohortsArgs = {
  input: Array<NewCohort>;
};

export type MutationCreateCohortUsersArgs = {
  input: Array<NewCohortUser>;
};

export type MutationCreateMeetingAttendanceRequestsArgs = {
  input: Array<NewMeetingAttendanceRequest>;
};

export type MutationCreateMeetingsArgs = {
  input: Array<NewMeeting>;
};

export type MutationCreateMeetingUsersArgs = {
  input: Array<NewMeetingUser>;
};

export type MutationCreateSeriesArgs = {
  input: Array<NewSeries>;
};

export type MutationCreateSeriesUsersArgs = {
  input: Array<NewSeriesUser>;
};

export type MutationDeleteCohortArgs = {
  id: Scalars['UUID']['input'];
};

export type MutationDeleteCohortUsersArgs = {
  input: Array<DeleteCohortUser>;
};

export type MutationDeleteMeetingsArgs = {
  meetingIDs: Array<Scalars['UUID']['input']>;
};

export type MutationDeleteSeriesArgs = {
  input: Array<DeleteSeries>;
};

export type MutationDeleteSeriesUserArgs = {
  input: DeleteSeriesUser;
};

export type MutationDeleteSeriesUsersArgs = {
  input: Array<DeleteSeriesUser>;
};

export type MutationDistributeUsersInSeriesArgs = {
  input: DistributeUsersInSeriesInput;
};

export type MutationRecordMeetingJoinArgs = {
  input: RecordMeetingJoinInput;
};

export type MutationRecordRecordingViewArgs = {
  input: RecordRecordingViewInput;
};

export type MutationResizeSeriesArgs = {
  input: ResizeSeriesInput;
};

export type MutationResyncCohortFacilitatorsArgs = {
  cohortId?: InputMaybe<Scalars['UUID']['input']>;
  dryRun?: Scalars['Boolean']['input'];
};

export type MutationResyncCohortUserEmailsArgs = {
  cohortId: Scalars['UUID']['input'];
};

export type MutationSwitchSeriesArgs = {
  input: NewSeriesSwitch;
};

export type MutationSyncMeetingAttendanceFromZoomArgs = {
  meetingId: Scalars['UUID']['input'];
};

export type MutationTransferSeriesUserArgs = {
  input: TransferSeriesUserDetails;
};

export type MutationTransferSeriesUsersArgs = {
  input: Array<TransferSeriesUserDetails>;
};

export type MutationUpdateCohortsArgs = {
  input: Array<UpdateCohort>;
};

export type MutationUpdateCohortUsersArgs = {
  input: Array<UpdateCohortUser>;
};

export type MutationUpdateMeetingAttendanceArgs = {
  input: Array<UpdateMeetingAttendance>;
};

export type MutationUpdateMeetingAttendanceRequestsArgs = {
  input: Array<UpdateMeetingAttendanceRequest>;
};

export type MutationUpdateMeetingsArgs = {
  input: Array<UpdateMeeting>;
};

export type MutationUpdateSeriesArgs = {
  input: Array<UpdateSeries>;
};

export type NewCohort = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  goToMarket: GoToMarket;
  maxSeriesSwitches?: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  relevantEnrollments?: InputMaybe<Array<NewRelevantEnrollment>>;
  showLeaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  type?: InputMaybe<CohortType>;
};

export type NewRelevantEnrollment = {
  bookingLink?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentType>;
  programKey: Scalars['String']['input'];
  unenrollOnWithdrawal: Scalars['Boolean']['input'];
};

export type NewCohortUser = {
  bio?: InputMaybe<Scalars['String']['input']>;
  cohortId: Scalars['UUID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  maxWeeklyMeetings?: Scalars['Int']['input'];
  roles: Array<CohortUserRole>;
  userKey?: InputMaybe<Scalars['String']['input']>;
};

export type NewMeetingAttendanceRequest = {
  meetingId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  requestedAttendanceStatus: MeetingAttendanceStatus;
  userKey: Scalars['String']['input'];
};

export type NewMeeting = {
  attendanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  cohortId: Scalars['UUID']['input'];
  conferenceLink?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['Time']['input'];
  facilitatorUserKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxSize?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
  seriesId?: InputMaybe<Scalars['UUID']['input']>;
  startAt: Scalars['Time']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** The Zoom meeting ID for this meeting's conference. Set by manage-web when it schedules a Zoom meeting. */
  zoomMeetingId?: InputMaybe<Scalars['String']['input']>;
};

export type NewMeetingUser = {
  meetingId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
};

export type NewSeries = {
  assignmentType?: InputMaybe<SeriesAssignmentType>;
  cohortId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  maxSize?: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type NewSeriesUser = {
  seriesId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
};

export type SeriesUser = {
  __typename?: 'SeriesUser';
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['UUID']['output'];
  seriesId: Scalars['UUID']['output'];
  updatedAt: Scalars['Time']['output'];
  userKey: Scalars['String']['output'];
};

export type DeleteCohortUser = {
  cohortId: Scalars['UUID']['input'];
  removalReason?: InputMaybe<CohortUserRemovalReason>;
  removalType: CohortUserRemovalType;
  userKey: Scalars['String']['input'];
};

export enum CohortUserRemovalReason {
  Dissatisfaction = 'DISSATISFACTION',
  Interest = 'INTEREST',
  Other = 'OTHER',
  Personal = 'PERSONAL',
  Time = 'TIME',
}

export enum CohortUserRemovalType {
  Blocked = 'BLOCKED',
  CohortEnded = 'COHORT_ENDED',
  Plagiarism = 'PLAGIARISM',
  Revoked = 'REVOKED',
  Transferred = 'TRANSFERRED',
  Withdrawal = 'WITHDRAWAL',
}

export type DeleteSeries = {
  seriesId: Scalars['UUID']['input'];
};

export type DeleteSeriesUser = {
  seriesId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
};

export type DistributeUsersInSeriesInput = {
  dryRun?: Scalars['Boolean']['input'];
  seriesIds: Array<Scalars['UUID']['input']>;
  userKeys: Array<Scalars['String']['input']>;
};

export type DistributeUsersSeriesSummary = {
  __typename?: 'DistributeUsersSeriesSummary';
  /** The total number of users in the series before distribution. */
  existingUserCount: Scalars['Int']['output'];
  maxSize: Scalars['Int']['output'];
  /** The users that were added to the series. */
  newSeriesUsers: Array<SeriesUser>;
  /** The total number of users in the series after distribution. */
  newUserCount: Scalars['Int']['output'];
  seriesId: Scalars['UUID']['output'];
};

export type RecordMeetingJoinInput = {
  meetingId: Scalars['ID']['input'];
  source: JoinSource;
};

export type RecordMeetingJoinPayload = {
  __typename?: 'RecordMeetingJoinPayload';
  /** Null when the join is recorded outside the meeting's attendance window (no attendance set). */
  attendanceStatus?: Maybe<MeetingAttendanceStatus>;
  meetingId: Scalars['ID']['output'];
  providerJoinUrl: Scalars['String']['output'];
};

export type RecordRecordingViewInput = {
  meetingId: Scalars['ID']['input'];
  source: JoinSource;
};

export type RecordRecordingViewPayload = {
  __typename?: 'RecordRecordingViewPayload';
  meetingId: Scalars['ID']['output'];
  recordingUrl: Scalars['String']['output'];
};

export type ResizeSeriesInput = {
  dryRun?: Scalars['Boolean']['input'];
  resizeSeries: Array<ResizeSeries>;
};

export type ResizeSeries = {
  maxSize?: Scalars['Int']['input'];
  seriesId: Scalars['UUID']['input'];
};

export type ResizedSeriesResult = {
  __typename?: 'ResizedSeriesResult';
  dryRun: Scalars['Boolean']['output'];
  existingSeries: ResizedSeriesSummary;
  newSeries: Array<ResizedSeriesSummary>;
  seriesId: Scalars['UUID']['output'];
};

export type ResizedSeriesSummary = {
  __typename?: 'ResizedSeriesSummary';
  maxSize: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numMeetings: Scalars['Int']['output'];
  numUsers: Scalars['Int']['output'];
  seriesId: Scalars['UUID']['output'];
};

export type NewSeriesSwitch = {
  cohortId: Scalars['UUID']['input'];
  destinationSeriesId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  originSeriesId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
};

export type SeriesSwitch = {
  __typename?: 'SeriesSwitch';
  cohortId: Scalars['UUID']['output'];
  createdAt: Scalars['Time']['output'];
  destinationSeriesId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  originSeriesId: Scalars['UUID']['output'];
  userKey: Scalars['String']['output'];
};

/**
 * Summary of a syncMeetingAttendanceFromZoom run. Nobody is ever marked absent, so this
 * reports only what the Zoom report could credit: matchedCount learners matched by email,
 * updatedCount newly written ATTENDED/ZOOM_API rows, and skippedCount matched learners
 * left untouched (a manual decision, a pending attendance request, or already recorded).
 * matchedParticipants carries each matched learner's Zoom join time and duration, ordered
 * by userKey. unmatchedParticipants are the Zoom participants that matched no invited
 * learner.
 */
export type SyncMeetingAttendanceFromZoomResult = {
  __typename?: 'SyncMeetingAttendanceFromZoomResult';
  matchedCount: Scalars['Int']['output'];
  matchedParticipants: Array<MatchedZoomParticipant>;
  skippedCount: Scalars['Int']['output'];
  unmatchedParticipants: Array<UnmatchedZoomParticipant>;
  updatedCount: Scalars['Int']['output'];
};

/**
 * An invited learner matched to the Zoom report, aggregated across all of their Zoom
 * sessions: the earliest join, the latest leave, and the total time spent in the meeting.
 * Join and leave times are null when Zoom omits them.
 */
export type MatchedZoomParticipant = {
  __typename?: 'MatchedZoomParticipant';
  durationSeconds: Scalars['Int']['output'];
  joinTime?: Maybe<Scalars['Time']['output']>;
  leaveTime?: Maybe<Scalars['Time']['output']>;
  userKey: Scalars['String']['output'];
};

/**
 * A Zoom participant from a synced meeting that could not be matched to a learner on
 * the roster (no email, or an email no invited learner has). Returned so a facilitator
 * can credit dial-ins by hand. Join and leave times are null when Zoom omits them.
 */
export type UnmatchedZoomParticipant = {
  __typename?: 'UnmatchedZoomParticipant';
  durationSeconds: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  joinTime?: Maybe<Scalars['Time']['output']>;
  leaveTime?: Maybe<Scalars['Time']['output']>;
  name: Scalars['String']['output'];
};

export type TransferSeriesUserDetails = {
  cohortId: Scalars['UUID']['input'];
  destinationSeriesId: Scalars['UUID']['input'];
  originSeriesId: Scalars['UUID']['input'];
  userKey: Scalars['String']['input'];
};

export type UpdateCohort = {
  banner?: InputMaybe<UpdateCohortBanner>;
  endDate?: InputMaybe<Scalars['Time']['input']>;
  goToMarket?: InputMaybe<GoToMarket>;
  id: Scalars['UUID']['input'];
  maxSeriesSwitches?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relevantEnrollmentsToAdd?: InputMaybe<Array<NewRelevantEnrollment>>;
  relevantEnrollmentsToRemove?: InputMaybe<Array<Scalars['UUID']['input']>>;
  showLeaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<CohortStatus>;
  type?: InputMaybe<CohortType>;
};

export type UpdateCohortBanner = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  subText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCohortUser = {
  bio?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  maxWeeklyMeetings?: InputMaybe<Scalars['Int']['input']>;
  rolesToAdd?: InputMaybe<Array<CohortUserRole>>;
  rolesToRemove?: InputMaybe<Array<CohortUserRole>>;
};

export type UpdateMeetingAttendance = {
  meetingId: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: MeetingAttendanceStatus;
  userKey: Scalars['String']['input'];
};

export type UpdateMeetingAttendanceRequest = {
  meetingId: Scalars['UUID']['input'];
  requestApproved: Scalars['Boolean']['input'];
  userKey: Scalars['String']['input'];
};

export type UpdateMeeting = {
  attendanceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  conferenceLink?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of a ContractService (from emc-content) to attach to or detach from this meeting.
   * Only valid for Connect Cohort meetings. Managed by emc-content service calls.
   *
   * To clear (detach), send the nil UUID "00000000-0000-0000-0000-000000000000".
   * Sending null or omitting the field is a no-op (leaves the current value unchanged).
   * Setting a value when one is already present will be rejected; clear it first.
   */
  contractServiceId?: InputMaybe<Scalars['UUID']['input']>;
  endAt?: InputMaybe<Scalars['Time']['input']>;
  facilitatorUserKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['UUID']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  maxSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordingUrl?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Time']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** The Zoom meeting ID for this meeting's conference. Set by manage-web when it schedules a Zoom meeting. */
  zoomMeetingId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSeries = {
  assignmentType?: InputMaybe<SeriesAssignmentType>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  maxSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MeetingUserSearchParams = {
  meetingId?: InputMaybe<Scalars['UUID']['input']>;
  paginationParams?: InputMaybe<PaginationParams>;
  sortBy?: InputMaybe<MeetingUserSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
  userKey?: InputMaybe<Scalars['String']['input']>;
};
